import { EventEmitter } from 'events';
import { fromEventPattern, from } from 'rxjs';
import { tap, shareReplay, map, scan, startWith, mergeWith, timeout, catchError, take, switchMap } from 'rxjs/operators';
import lodashGet from 'lodash/get';
export class P2PMuteStream {
    constructor() {
        this.sdk = null;
        this.subject = null;
        this.myEvent = new EventEmitter();
        const { updateMute } = P2PMuteStream.Event_Name_Collections;
        const onUpdateMute = (handler) => {
            this.myEvent.addListener(updateMute, handler);
        };
        const offUpdateMute = (handler) => {
            this.myEvent.removeListener(updateMute, handler);
        };
        this.toggleSubject = fromEventPattern(onUpdateMute, offUpdateMute);
    }
    init(sdk) {
        this.sdk = sdk;
        this.subject = this._onmutelist().pipe(mergeWith(this._onsyncmarkinmutelist(), this.toggleSubject), tap(args => {
            console.log('[im.p2pmute]combineLatest', args);
        }), scan(this._computeTotalMute, []), catchError(() => from(Promise.resolve([]))), startWith([]), shareReplay(1));
        this.subject.subscribe(args => {
            console.log('[im.p2pmute]subscribe', args);
        });
    }
    _computeTotalMute(total, current) {
        const _list = new Set([...total, ...(Array.isArray(current) ? current : [])]);
        if (lodashGet(current, 'isAdd', undefined) === true) {
            _list.add(current.account);
        }
        else if (lodashGet(current, 'isAdd', undefined) === false) {
            _list.delete(current.account);
        }
        return [..._list];
    }
    _onmutelist() {
        const onconnect = (handler) => {
            this.sdk.subscrible('onconnect', handler);
        };
        const offconnect = (handler) => {
            this.sdk.subscrible('onconnect', handler);
        };
        const onmute = (handler) => {
            this.sdk.subscrible('onmutelist', handler);
        };
        const offmute = (handler) => {
            this.sdk.unSubcrible('onmutelist', handler);
        };
        const $event = fromEventPattern(onconnect, offconnect).pipe(switchMap(() => fromEventPattern(onmute, offmute).pipe(timeout(30 * 1000))), take(1));
        return $event
            .pipe(catchError(error => {
            console.log('[im.p2pmutelist]error', error);
            const $request = this.sdk.excute('getRelations', {});
            return from($request).pipe(map(({ mutelist }) => mutelist));
        }), map(list => list.map(item => item.account)), tap((args) => {
            console.log('[im.p2pmute]onmute', args);
        }))
            .pipe(catchError(() => from(Promise.resolve([]))), startWith([]));
    }
    _onsyncmarkinmutelist() {
        const onsyncmarkinmutelist = (handler) => {
            this.sdk.subscrible('onsyncmarkinmutelist', handler);
        };
        const offsyncmarkinmutelist = (handler) => {
            this.sdk.unSubcrible('onsyncmarkinmutelist', handler);
        };
        return fromEventPattern(onsyncmarkinmutelist, offsyncmarkinmutelist).pipe(tap(args => {
            console.log('[im.p2pmute]onsync', args);
        }));
    }
    async toggleMute(params) {
        const { account, isAdd } = await this.sdk.excute('markInMutelist', params);
        const { updateMute: eventName } = P2PMuteStream.Event_Name_Collections;
        this.myEvent.emit(eventName, { account, isAdd });
    }
    getSubject() {
        return this.subject;
    }
}
P2PMuteStream.Event_Name_Collections = {
    updateMute: 'updateMute',
};
